import axios from "axios";

const bodySubmitNewCart = async (state, appState) => {
  let form = {};

  const bonuses = await _getBonuses(state);
  const customerForm = await _getCustomerForm(state);
  const paymentForm = await _getPaymentForm(state);
  const deliveryForm = await _getDeliveryForm(state, appState);
  const addressForm = await _getAddressForm(state, appState);

  form = {
    ...bonuses,
    ...customerForm,
    ...paymentForm,
    ...deliveryForm,
    ...addressForm,
    promo: state?.checkoutData?.promo || ""
  }
  return form
}

const _getBonuses = (state) => {
  const useActiveBonuses = state?.useActiveBonuses || 0;
  if (useActiveBonuses <= 0) {
    return {}
  }

  return {
    "use_bonuses": 1,
    "use_bonuses_value": useActiveBonuses,
  }
}
const _getCustomerForm = (state) => {
  let _body = {
    "name": state?.userInfo?.name,
    "phone": (state?.userInfo?.phone || "").replace(/\D+/g, ""),
    "legal_type": 1,
  };
  if (state?.userInfo?.email) {
    _body.email = state?.userInfo?.email;
  }
  if (state?.userInfo?.is_marketing) {
    _body.is_marketing = state?.userInfo?.is_marketing
  }
  return {
    "CustomerForm": _body,
  }
}
const _getPaymentForm = (state) => {
  const {
    selectedPayment,
  } = state;
  const paymentsList = state?.checkoutData?.payments || [];
  const payment = paymentsList.find((t) => t.class === selectedPayment);

  return {
    "PaymentForm": {
      "id": payment?.id
    },
  }
}
const _getDeliveryForm = async (state, appState) => {
  let DeliveryForm = {}
  if (state?.selectedDeliveryMethod === "pickup") {
    const point = state?.pickupPointsInfo?.point || {};
    let shop_id = point?.code;
    DeliveryForm = {
      "id": point?.classPoint?.id,
      "place_id": point?.code,
      "address": point?.address,
      shop_id
    }
  }
  if (state?.selectedDeliveryMethod === "delivery") {
    const deliveryInfo = state?.deliveryInfo;
    const fullAddress = [
      appState?.config?.city?.data?.city_name,
      (deliveryInfo?.shortAddress || deliveryInfo?.fullAddress)
    ].filter((t) => !!t).join(" ");
    const infoAddress = await _dadataFullAddress(fullAddress);

    let house = [infoAddress?.data?.house_type_full, infoAddress?.data?.house].filter((t) => !!t);
    if (infoAddress?.data?.block) {
      house.push([infoAddress?.data?.block_type, infoAddress?.data?.block].filter((t) => !!t).join(" "))
    }

    let address = [
      appState?.config?.city?.data?.city_name,
      infoAddress?.data?.street,
      (house.filter((t) => !!t).join(" ")),
      Boolean(deliveryInfo?.apartment) && `Кв./офис ${deliveryInfo?.apartment}`,
      Boolean(deliveryInfo?.entrance) && `Подъезд ${deliveryInfo?.entrance}`,
      Boolean(deliveryInfo?.floor) && `Этаж ${deliveryInfo?.floor}`,
      Boolean(deliveryInfo?.intercom) && `Домофон ${deliveryInfo?.intercom}`,
      Boolean(deliveryInfo?.mailIndex) && `Индекс ${deliveryInfo?.mailIndex}`,
      Boolean(deliveryInfo?.comment) && `(${deliveryInfo?.comment})`,
    ].filter((t) => !!t).join(", ");


    const deliveryName = (state?.checkoutData?.deliveries || []).find((t) => t.id === deliveryInfo?.courierId)?.class;
    let city = appState?.config?.city?.data?.city_name;
    if (deliveryName === 'courier') {
      city = appState?.config?.city?.data?.city_id;
    }

    DeliveryForm = {
      "id": deliveryInfo?.courierId,
      "city": city,
      "zip": deliveryInfo?.mailIndex || infoAddress?.data?.postal_code,
      "address": address,
      "kladr_id": appState?.config?.city?.model?.cdek_id
    };

    if (deliveryName === 'yandex-day-delivery') {
      DeliveryForm.coordinates = [infoAddress?.data?.geo_lat, infoAddress?.data?.geo_lon]
        .map((t) => Number.parseFloat(t))
        .reverse();
    }
  }

  return {
    DeliveryForm
  }
}

const _getAddressForm = async (state, appState) => {
  let AddressForm = {}

  let fullAddress = "";
  if (state?.selectedDeliveryMethod === "pickup") {
    fullAddress = [
      appState?.config?.city?.data?.city_name,
      state?.pickupPointsInfo?.point?.address
    ].filter((t) => !!t).join(" ");
    const addresInfo = await _dadataFullAddress(fullAddress);
    AddressForm = {
      "zip": addresInfo?.data?.postal_code,
      "city_name": addresInfo?.data?.city,
      "street": addresInfo?.data?.street,
      "house": addresInfo?.data?.house,
      "lat": addresInfo?.data?.geo_lat,
      "lon": addresInfo?.data?.geo_lon
    };
  }
  if (state?.selectedDeliveryMethod === "delivery") {
    const deliveryInfo = state?.deliveryInfo;
    const fullAddress = [
      appState?.config?.city?.data?.city_name,
      (deliveryInfo?.shortAddress || deliveryInfo?.fullAddress)
    ].filter((t) => !!t).join(" ");
    const addresInfo = await _dadataFullAddress(fullAddress);

    let house = [addresInfo?.data?.house];
    if (addresInfo?.data?.block) {
      house.push(`/${addresInfo?.data?.block}`)
    }

    AddressForm = {
      "city_name": appState?.config?.city?.data?.city_name,
      "zip": addresInfo?.data?.postal_code || deliveryInfo?.mailIndex,
      "street": addresInfo?.data?.street || deliveryInfo?.shortAddress,
      "house": house.filter((t) => !!t).join(""),
      "flat": deliveryInfo?.apartment,
      "intercom": deliveryInfo?.intercom,
      "entrance": deliveryInfo?.entrance,
      "floor": deliveryInfo?.floor,
      "comment": deliveryInfo?.comment
    }
  }

  return {
    AddressForm
  }
}
const _dadataFullAddress = async (fullAddress) => {
  const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
  const dadataApiKey = process.env.dadataApiKey;

  const information = await axios.post(url, {query: fullAddress}, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Token " + dadataApiKey,
    },
  }).then((res) => {
    return res?.data?.suggestions?.[0] || null
  }).catch(() => {
    return null
  });
  return information
}

export default bodySubmitNewCart
export {
  _getDeliveryForm,
  _getAddressForm
}


const initForm = {
  "promo": "",
  "note": "",
}
